module.exports = __webpack_public_path__ + "static/media/display-suite-03.d6487860.jpg";